module.exports = __webpack_public_path__ + "static/media/modal-close.3b57eaf7.svg";